import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 310,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  borderRadius: '8px'
};

export default function ChangeStatusAlertModal(props) {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'chat' });

  const [open, setOpen] = useState(props.open)
  useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  return (
    <Modal
      open={open}
      onClose={props.handleClose}
      dir={direction}
    >
      <Box sx={style}>
        <Typography variant="caption" component="span" align="center">
          {t('change_status_alert')}
        </Typography>
      </Box>
    </Modal>
  );
}
